export function isHttpUrl(url){
  return /^(http|https|ftp):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(url);
  // try{
  //   new URL(url);
  //   return true;
  // }catch(e){
  //   return false;
  // }
}